import { getDeviceInfo } from './deviceInfo';
export const isIosNative = () => {
    const deviceInfo = getDeviceInfo();
    return (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isNative) === true && (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.deviceOS) === 'ios';
};
